import { t } from 'i18next'

export const TOKUSHOHO_TITLE = t('tokushoho.title')
